import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Agent`;
const baseServiceUrlFileManager = `/api/v1/FileManager`;
const env = process.env;



const ApiAgent = {
  getAllAgent: (params) => {
    const url = `${baseServiceUrl}/getAllAgent`;
    return ServiceApi.get(url, { params });
  },
  getAllAgentsName: () => {
    const url = `${baseServiceUrl}/getAllAgentsName`;
    return ServiceApi.get(url);
  },
  getAllUsedPromoCodeByUser: (params) => {
    const url = `${baseServiceUrl}/getAllUsedPromoCodeByUser`;
    return ServiceApi.get(url, { params });
  },
  getAllAgentById: (params) => {
    const url = `${baseServiceUrl}/getAllAgentById?id=` + params;
    return ServiceApi.get(url);
  },
  getAgentApprovalStatus: () => {
    const url = `${baseServiceUrl}/getAgentApprovalStatus`;
    return ServiceApi.get(url);
  },
  createAgency: (params) => {
    const url = `${baseServiceUrl}/createAgency`;
    return ServiceApi.post(url, params);
  },
  createAgent: (params) => {
    const url = `${baseServiceUrl}/createAgent`;
    return ServiceApi.post(url, params);
  },
  updateAgent: (params) => {
    const url = `${baseServiceUrl}/updateAgent`;
    return ServiceApi.put(url, params);
  },
  getFile: (params) => {
    const url = `${baseServiceUrl}/getFile`;
    return ServiceApi.get(url, { params: params, baseURL: env.REACT_APP_PHOTOPATH_Agent, responseType: 'blob' });

  },
  getFileOfFileManager: (params) => {
    const url = `${baseServiceUrlFileManager}/getFile`;
    return ServiceApi.get(url, { params: params, baseURL: env.REACT_APP_PHOTOPATH_Agent, responseType: 'blob' });
  },
  updateAgentUser: (params) => {
    const url = `${baseServiceUrl}/updateAgentUser`;
    return ServiceApi.put(url, params);
  },
  getAgentUserById: (params) => {
    const url = `${baseServiceUrl}/getAgentUserById?id=${params.id}`;
    return ServiceApi.get(url, params);
  },
  updateAgentIsActive: (params) => {
    const url = `${baseServiceUrl}/updateAgentIsActive`;
    return ServiceApi.put(url, params);
  }

};

export default ApiAgent;


